import './components/share'

import './scss/st7/styles.scss'
